import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { getPageNameFromUri } from 'domain/router'
import * as Actions from 'store/actions/index.ts'
import {
  getDaysSinceStartSale,
  getOperationCode,
  getSaleStartTime,
  getSubUniverseName,
  getUniverseName,
  getUri
} from 'store/selectors'
import { track } from 'tracking/mixPanel'

const mapStateToMPEvent = (eventName, state, action) => {
  const { eventType, position, productId, productName, tooltipName } = action.payload

  return ({
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Interaction Type': eventType,
    'Operation Code': getOperationCode(state),
    'Page Name': getPageNameFromUri(getUri(state)),
    'Product': productName,
    'Product ID': productId,
    'Sale Start Time': getSaleStartTime(state),
    'Tooltip Name': tooltipName,
    'Tooltip Position': position,
    'Under Universe': getSubUniverseName(state),
    'Universe': getUniverseName(state)
  })
}

const tooltipEventEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.tooltip.TOOLTIP_EVENT),
  tap(action => {
    const eventName = 'View Tooltip'

    track(eventName, mapStateToMPEvent(eventName, state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default tooltipEventEpic
